// AUTO-GENERIERT aus bestand-analyse/ (SEA Teil-B-Schlüssel + Forst-Legende).
// SEED-Vokabular für den Bestand-Konverter. PRODUKTION soll die Artenliste
// aus der bpweb-listen-DB beziehen (Regel: Listen nur in DB). Hier nur als
// Default/Fallback + für Tests. Strukturelle Wörterbücher: siehe bestand-vocabulary.ts

export interface SeaArt { kurz: string; lang: string; bagr: string; }

/** 142 kanonische Arten: SEA-Teil-B-Kurzformen + Strauch-Codes aus der Forst-Legende. */
export const SEA_BAUMARTEN: readonly SeaArt[] = [
  { kurz: 'GKI', lang: 'Gemeine Kiefer', bagr: 'Ki' },
  { kurz: 'WKI', lang: 'Weymouthskiefer', bagr: 'sNDH' },
  { kurz: 'SKI', lang: 'Schw arzkiefer', bagr: 'Ki' },
  { kurz: 'MKI', lang: 'Murraykiefer', bagr: 'Ki' },
  { kurz: 'RKI', lang: 'Rumelische Kiefer', bagr: 'Ki' },
  { kurz: 'BKI', lang: 'Bergkiefer', bagr: 'Ki' },
  { kurz: 'ZKI', lang: 'Zirbelkiefer', bagr: 'Ki' },
  { kurz: 'PKI', lang: 'Gelbkiefer', bagr: 'Ki' },
  { kurz: 'KIS', lang: 'Sonstige Kiefer', bagr: 'Ki' },
  { kurz: 'ELA', lang: 'Europäische Lärche', bagr: 'LA' },
  { kurz: 'JLA', lang: 'Japanische Lärche', bagr: 'LA' },
  { kurz: 'HLA', lang: 'Hybridlärche', bagr: 'LA' },
  { kurz: 'LAS', lang: 'Sonstige Lärchen', bagr: 'LA' },
  { kurz: 'GFI', lang: 'Gemeine Fichte', bagr: 'FI' },
  { kurz: 'SFI', lang: 'Sitkafichte', bagr: 'FI' },
  { kurz: 'WFI', lang: 'Weißfichte', bagr: 'sNDH' },
  { kurz: 'OFI', lang: 'Omorikafichte', bagr: 'FI' },
  { kurz: 'BFI', lang: 'Stechfichte, Blaufichte', bagr: 'sNDH' },
  { kurz: 'EFI', lang: 'Engelmannfichte', bagr: 'sNDH' },
  { kurz: 'MFI', lang: 'Schw arzfichte', bagr: 'sNDH' },
  { kurz: 'RFI', lang: 'Rotfichte', bagr: 'sNDH' },
  { kurz: 'FIS', lang: 'Sonstige Fichten', bagr: 'sNDH' },
  { kurz: 'WTA', lang: 'Weißtanne', bagr: 'sNDH' },
  { kurz: 'KTA', lang: 'Küstentanne', bagr: 'sNDH' },
  { kurz: 'CTA', lang: 'Coloradotanne', bagr: 'sNDH' },
  { kurz: 'NTA', lang: 'Nordmanntanne', bagr: 'sNDH' },
  { kurz: 'ETA', lang: 'Amerikanische Edeltanne', bagr: 'sNDH' },
  { kurz: 'HTA', lang: 'Nikkotanne', bagr: 'sNDH' },
  { kurz: 'VTA', lang: 'Veitchtanne', bagr: 'sNDH' },
  { kurz: 'TAS', lang: 'Sonstige Tannen', bagr: 'sNDH' },
  { kurz: 'GDG', lang: 'Grüne Douglasie', bagr: 'DG' },
  { kurz: 'BDG', lang: 'Blaue Douglasie', bagr: 'DG' },
  { kurz: 'CDG', lang: 'Graue Douglasie', bagr: 'DG' },
  { kurz: 'DGS', lang: 'Sonstige Douglasien', bagr: 'DG' },
  { kurz: 'RLB', lang: 'Riesenlebensbaum', bagr: 'sNDH' },
  { kurz: 'MLB', lang: 'Morgenländ.Lebensbaum', bagr: 'sNDH' },
  { kurz: 'ALB', lang: 'Abendländ.Lebensbaum', bagr: 'sNDH' },
  { kurz: 'LBS', lang: 'Sonstige Lebensbäume', bagr: 'sNDH' },
  { kurz: 'LLZ', lang: 'Law son-Scheinzypresse', bagr: 'sNDH' },
  { kurz: 'LZS', lang: 'Sonstige Scheinzypressen', bagr: 'sNDH' },
  { kurz: 'KHT', lang: 'Kanadische Hemlocktanne', bagr: 'sNDH' },
  { kurz: 'WHT', lang: 'Westamerikanische Hemlocktanne', bagr: 'sNDH' },
  { kurz: 'HTS', lang: 'Sonstige Hemlocktannen', bagr: 'sNDH' },
  { kurz: 'EIB', lang: '(Beeren-) Eibe', bagr: 'sNDH' },
  { kurz: 'GWA', lang: 'Gemeiner Wacholder', bagr: 'sNDH' },
  { kurz: 'WAS', lang: 'Sonstige Wacholder', bagr: 'sNDH' },
  { kurz: 'MA', lang: 'Mammutbäume', bagr: 'sNDH' },
  { kurz: 'NDS', lang: 'Sonstige Nadelbaumarten', bagr: 'sNDH' },
  { kurz: 'EI', lang: '(SEI-/TEI-Bastarde)', bagr: 'EI' },
  { kurz: 'SEI', lang: 'Stieleiche', bagr: 'EI' },
  { kurz: 'TEI', lang: 'Traubeneiche', bagr: 'EI' },
  { kurz: 'ZEI', lang: 'Zerreiche', bagr: 'EI' },
  { kurz: 'PEI', lang: 'Sumpfeiche', bagr: 'EI' },
  { kurz: 'REI', lang: 'Roteiche', bagr: 'sHLB' },
  { kurz: 'EIS', lang: 'Sonstige Eiche', bagr: 'sHLB' },
  { kurz: 'RBU', lang: 'Rotbuche', bagr: 'BU' },
  { kurz: 'BUS', lang: 'Sonstige Buchen', bagr: 'BU' },
  { kurz: 'HBU', lang: 'Hainbuche', bagr: 'sHLB' },
  { kurz: 'GES', lang: 'Gemeine Esche', bagr: 'ELB' },
  { kurz: 'WES', lang: 'Weißesche', bagr: 'sHLB' },
  { kurz: 'ESS', lang: 'Sonstige Eschen', bagr: 'sHLB' },
  { kurz: 'BAH', lang: 'Bergahorn', bagr: 'ELB' },
  { kurz: 'SAH', lang: 'Spitzahorn', bagr: 'ELB' },
  { kurz: 'FAH', lang: 'Feldahorn', bagr: 'ELB' },
  { kurz: 'IAH', lang: 'Silberahorn', bagr: 'sWLS' },
  { kurz: 'EAH', lang: 'Eschenblättr. Ahorn', bagr: 'sWLS' },
  { kurz: 'AHS', lang: 'Sonstige Ahornart', bagr: 'sHLB' },
  { kurz: 'BRU', lang: 'Bergrüster, Bergulme', bagr: 'ELB' },
  { kurz: 'WRU', lang: 'Weißrüster, Flatterulme', bagr: 'ELB' },
  { kurz: 'FRU', lang: 'Feldrüster, Feldulme', bagr: 'ELB' },
  { kurz: 'HRU', lang: 'Holländische Rüster, Bastard', bagr: 'ELB' },
  { kurz: 'RUS', lang: 'Sonstige Rüstern', bagr: 'ELB' },
  { kurz: 'RO', lang: 'Gemeine Robinie', bagr: 'sHLB' },
  { kurz: 'GLE', lang: 'Amerikanische Gleditschie', bagr: 'sWLS' },
  { kurz: 'EK', lang: 'Edelkastanie', bagr: 'ELB' },
  { kurz: 'NB', lang: 'Nußbaum-Arten', bagr: 'sHLB' },
  { kurz: 'NBW', lang: 'Walnuss', bagr: 'ELB' },
  { kurz: 'NBS', lang: 'Schw arznuss', bagr: 'sHLB' },
  { kurz: 'HI', lang: 'Hickory-Arten', bagr: 'sHLB' },
  { kurz: 'BHA', lang: 'Baumhasel', bagr: 'sWLS' },
  { kurz: 'VKB', lang: 'Vogelkirsche (-baum)', bagr: 'ELB' },
  { kurz: 'GTK', lang: 'Gew öhnliche Traubenkirsche', bagr: 'sWLS' },
  { kurz: 'STK', lang: 'Spätblühende Traubenkirsche', bagr: 'sWLS' },
  { kurz: 'AB', lang: 'Wildapfel(-baum)', bagr: 'sHLB' },
  { kurz: 'BB', lang: 'Wildbirne(-baum)', bagr: 'sHLB' },
  { kurz: 'PB', lang: 'Wildpflaume(-baum)', bagr: 'sHLB' },
  { kurz: 'OBS', lang: 'Sonstige Obstbäume', bagr: 'sHLB' },
  { kurz: 'PLT', lang: 'Platanen', bagr: 'sHLB' },
  { kurz: 'HLS', lang: 'Sonst. Hartlaubbaumarten', bagr: 'sHLB' },
  { kurz: 'GBI', lang: 'Gemeine Birke, Sand-Birke', bagr: 'BI' },
  { kurz: 'MBI', lang: 'Moorbirke', bagr: 'BI' },
  { kurz: 'BIS', lang: 'Sonstige Birken', bagr: 'BI' },
  { kurz: 'RER', lang: 'Roterle, Schw arzerle', bagr: 'RER' },
  { kurz: 'WER', lang: 'Weißerle, Grauerle', bagr: 'sWLS' },
  { kurz: 'GER', lang: 'Grünerle', bagr: 'sWLS' },
  { kurz: 'WLI', lang: 'Winterlinde', bagr: 'ELB' },
  { kurz: 'SLI', lang: 'Sommerlinde', bagr: 'ELB' },
  { kurz: 'LIS', lang: 'Sonstige Linden', bagr: 'sWLS' },
  { kurz: 'SPA', lang: 'Europäische Schw arzpappel', bagr: 'PA' },
  { kurz: 'HPA', lang: 'Schw arzpappelhybriden', bagr: 'PA' },
  { kurz: 'TPA', lang: 'Trichocarpa-Pappel', bagr: 'PA' },
  { kurz: 'BPA', lang: 'Balsampappel-Hybriden', bagr: 'PA' },
  { kurz: 'GPA', lang: 'Graupappel + Hybriden', bagr: 'PA' },
  { kurz: 'WPA', lang: 'Silberpappel, Weißpappel', bagr: 'PA' },
  { kurz: 'AS', lang: 'Aspe', bagr: 'BI' },
  { kurz: 'HAS', lang: 'Aspen-Hybriden', bagr: 'BI' },
  { kurz: 'PAS', lang: 'Sonstige Pappeln', bagr: 'PA' },
  { kurz: 'WWE', lang: 'Weißw eide, Silberw eide', bagr: 'sWLS' },
  { kurz: 'BWE', lang: 'Bruchw eide, Knackw eide', bagr: 'sWLS' },
  { kurz: 'FWE', lang: 'Fahlw eide, Baumw eiden-Hybriden', bagr: 'sWLS' },
  { kurz: 'SWE', lang: 'Salw eide', bagr: 'sWLS' },
  { kurz: 'WEB', lang: 'Sonstige Baumw eiden', bagr: 'sWLS' },
  { kurz: 'RK', lang: 'Roßkastanie', bagr: 'sWLS' },
  { kurz: 'EB', lang: 'Gemeine Eberesche', bagr: 'sWLS' },
  { kurz: 'EEB', lang: 'Edel-Eberesche', bagr: 'sWLS' },
  { kurz: 'ME', lang: 'Echte Mehlbeere', bagr: 'sWLS' },
  { kurz: 'EL', lang: 'Elsbeere', bagr: 'ELB' },
  { kurz: 'SG', lang: 'Speierling', bagr: 'ELB' },
  { kurz: 'MES', lang: 'Sonstige Mehlbeeren', bagr: 'sWLS' },
  { kurz: 'GO', lang: 'Gemeiner Götterbaum', bagr: 'sWLS' },
  { kurz: 'MB', lang: 'Maulbeeren', bagr: 'sWLS' },
  { kurz: 'WLS', lang: 'Sonstige Weichlaubbaumarten', bagr: 'sWLS' },
  { kurz: 'BG', lang: 'Besen-Ginster', bagr: '' },
  { kurz: 'CRO', lang: 'Hecken-Rose', bagr: '' },
  { kurz: 'ESB', lang: 'Pfaffenhütchen', bagr: '' },
  { kurz: 'EWD', lang: 'Eingriffeliger Weißdorn', bagr: '' },
  { kurz: 'FLB', lang: 'Faulbaum', bagr: '' },
  { kurz: 'GBE', lang: 'Gemeine Berberitze', bagr: '' },
  { kurz: 'GSL', lang: 'Gemeiner Schneeball', bagr: '' },
  { kurz: 'GWE', lang: 'Grau-Weide, Asch-Weide', bagr: '' },
  { kurz: 'HRS', lang: 'Hunds-Rose', bagr: '' },
  { kurz: 'KRE', lang: 'Kreuzdorn', bagr: '' },
  { kurz: 'KWE', lang: 'Korb-Weide', bagr: '' },
  { kurz: 'LWE', lang: 'Lorbeer-Weide', bagr: '' },
  { kurz: 'OWE', lang: 'Ohr-Weide', bagr: '' },
  { kurz: 'PWE', lang: 'Purpur-Weide', bagr: '' },
  { kurz: 'RHR', lang: 'Blutroter Hartriegel', bagr: '' },
  { kurz: 'SDO', lang: 'Schlehe', bagr: '' },
  { kurz: 'SHA', lang: 'Strauch-Hasel', bagr: '' },
  { kurz: 'SHB', lang: 'Schwarzer Holunder', bagr: '' },
  { kurz: 'SHO', lang: 'Schwarzer Holunder', bagr: '' },
  { kurz: 'WRS', lang: 'Wein-Rose', bagr: '' },
  { kurz: 'ZWD', lang: 'Zweigriffeliger Weißdorn', bagr: '' },
];

/** Kartierer-Kurzform → kanonischer SEA-Code (belastbare Aliasse; Rest → Prüfung). */
export const ART_ALIAS: Readonly<Record<string, string>> = {
  'BI': 'GBI',
  'EBE': 'EB',
  'LÄ': 'ELA',
  'ELÄ': 'ELA',
  'DGL': 'GDG',
  'ER': 'RER',
  'ERL': 'RER',
  'FI': 'GFI',
  'BU': 'RBU',
  'KI': 'GKI',
  'GK': 'GKI',
  'GF': 'GFI',
  'TA': 'WTA',
  'SBI': 'GBI',
  'KIE': 'GKI',
  'RERL': 'RER',
  'RBI': 'GBI',
  // aus open_codes.txt (vom Fachverantwortlichen aufgelöst); „weg" = ignoriert
  'FB': 'FLB',     // Faulbaum
  'ROB': 'RO',     // Robinie
  'STKI': 'STK',   // Spätblühende Traubenkirsche
  'SD': 'SDO',     // Schwarzdorn (= Schlehe)
  'AH': 'AHS',     // Ahorn (unspez. → Sonstige Ahornart)
  'HRO': 'HRS',    // Rose (→ Hunds-Rose)
  'TKI': 'GTK',    // Traubenkirsche
  'BP': 'BPA',     // Balsampappel
  'PA': 'PAS',     // Pappel (unspez. → Sonstige Pappeln)
  'UL': 'RUS',     // Ulme/Rüster (unspez. → Sonstige Rüstern)
  'WAC': 'GWA',    // Wacholder
  'WEI': 'WEB',    // Weide (unspez. → Sonstige Baumweiden)
  'ELS': 'EL',     // Elsbeere
  'RKA': 'RK',     // Rosskastanie
  'FUL': 'WRU',    // Flatterulme (= Weißrüster)
};
